import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KiConfig } from '../modules/project/admin/projectAdminKnowledgeIndex/knowledge-index.types';

export interface AiSettingValue {
    value: boolean | string | null;
    inherited: boolean;
    source: string;
}

export interface AiFlowSettings {
    ai_blocked_by: string | null;
    ai_enabled:   AiSettingValue;
    llm_provider: AiSettingValue;
    llm_model:    AiSettingValue;
    llm_key:      AiSettingValue;
}

export interface AiFlowUpdate {
    ai_enabled?:   boolean | '';
    llm_provider?: string;
    llm_model?:    string;
    llm_key?:      string;
}

@Injectable()
export class AiFlowService {

    constructor(private http: HttpClient) {}

    getAiConfig(projectId: number): Promise<AiFlowSettings> {
        return this.http.get<AiFlowSettings>(`/api/setting/${projectId}/aiconfig`)
            .toPromise();
    }

    postAiConfig(projectId: number, data: AiFlowUpdate): Promise<AiFlowSettings> {
        return this.http.post<AiFlowSettings>(`/api/setting/${projectId}/aiconfig`, data)
            .toPromise();
    }

    getKnowledgeIndexConfig(projectId: number): Promise<KiConfig> {
        return this.http.get<KiConfig>(`/api/setting/${projectId}/knowledgeindexconfig`)
            .toPromise();
    }

    postKnowledgeIndexConfig(projectId: number, data: Partial<KiConfig>): Promise<KiConfig> {
        return this.http.post<KiConfig>(`/api/setting/${projectId}/knowledgeindexconfig`, data)
            .toPromise();
    }

    /** Generate a short summary of a wiki page edit from a word-level diff (see StringDiffService.diffString). */
    generateWikiChangeSummary(projectId: number, diff: string): Promise<{ summary: string }> {
        return this.http.post<{ summary: string }>(`/flow/project/${projectId}/wiki/summarize-changes`, { diff })
            .toPromise();
    }
}
